import * as mail from 'mailcheck'

window.emailSuggestionDomains = window.emailSuggestionDomains || []
window.emailSuggestionSecondLevelDomains = window.emailSuggestionSecondLevelDomains || []
window.emailSuggestionTopLevelDomains = window.emailSuggestionTopLevelDomains || []

/**
 * javaslat kérése, inputra, ha van akkor megjelenitjuk ha nincs akkor rejtjük
 *
 * @param email
 * @returns {{hasSuggestion: boolean, emailSuggestion: string}}
 */
window.suggestAutoCorrectMail = function (email) {
  mail.defaultDomains = window.emailSuggestionDomains
  mail.defaultSecondLevelDomains = window.emailSuggestionSecondLevelDomains
  mail.defaultTopLevelDomains = window.emailSuggestionTopLevelDomains
  const result = {
    emailSuggestion: '',
    hasSuggestion: false,
  }
  mail.run({
    email: email,
    domains: window.emailSuggestionDomains,
    topLevelDomains: window.emailSuggestionSecondLevelDomains,
    secondLevelDomains: window.emailSuggestionTopLevelDomains,
    suggested: function (suggestion) {
      result.emailSuggestion = suggestion.full
      result.hasSuggestion = true
    },
    empty: function () {
      // nincs javaslat
    },
  })
  return result
}

window.disableScroll = function () {
  document.body.classList.add('no-scroll')
}

window.enableScroll = function () {
  document.body.classList.remove('no-scroll')
}

/**
 * Vue Loader eltüntetése
 * ki lett helyezve, hogy a lang betöltés után tüntessük el
 */
window.removeLoader = function () {
  const loaderWrapper = document.body.querySelector('.page-loader-wrapper')
  if (loaderWrapper) {
    loaderWrapper.classList.add('hide-loader')
    loaderWrapper.addEventListener('transitionend', function (e) {
      loaderWrapper.classList.add('hidden-loader')
    }, {
      capture: false,
      once: true,
      passive: false,
    })
  }
}

/**
 * ha van ez a method akkor igen
 *
 * @return {boolean}
 */
window.isJsBundleLoaded = function () {
  return true
}
